import {
  AvailableSeats,
  BeketPaginationPage,
  BeketTicket,
  BeketTicketDetail,
  CountriesSearchBeketResult,
  ResponsePage,
  SearchFreeSeatsParams,
} from 'shared/api/beket/search/model.ts'
import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general.ts'

export const SearchApiBeket = {
  searchCity(name: string) {
    return clientApi.get<CountriesSearchBeketResult>(
      `/bus/cities?name=${name || ''}`,
    )
  },

  searchTicket(params: BeketPaginationPage, abort?: AbortSignal) {
    return clientApi.get<ResponsePage<BeketTicket[]>>(`/bus/schedules`, {
      params,
      signal: abort,
    })
  },

  searchTicketDetail(ticketId: string, data: any) {
    return clientApi.get<ResponsePage<BeketTicketDetail>>(
      `/bus/schedules/${ticketId}`,
      {
        params: data,
      },
    )
  },

  searchCalendarFreeSeats(params: SearchFreeSeatsParams) {
    return clientApi.get<Response<AvailableSeats[]>>(`/bus/calendar`, {
      params,
    })
  },

  getShareTicketDetail(shareCode: string) {
    return clientApi.get<ResponsePage<BeketTicket>>(
      `/bus/schedules/share/${shareCode}`,
    )
  },
}
